import * as angular from "angular";
import {IController} from "angular";
import {SelectFilterType} from "../../types/select-filter.type";

export class BringozSelectComponent implements IController {

  type: string;
  options: string[];
  optionIds: string[];
  excludedIds: string[];
  value: string;
  isRequired: boolean;
  isDisabled: boolean;
  ngPlaceholder: string;
  optionsPrefix: string;
  selectParams: any;
  onSelect: Function;

  public selectFilterType: typeof SelectFilterType = SelectFilterType;

}


angular
  .module('bringoz.admin.commons')
  .component('bringozSelect', {
    require: {
      form: '^form'
    },
    bindings: {
      type: '<',
      value: '<',
      options: '<',
      optionIds: '<?',
      excludedIds: '<?',
      optionsPrefix: '@?',
      isRequired: '<?',
      isDisabled: '<?',
      selectParams: '<?',
      ngPlaceholder: '@?',
      onSelect: '&'
    },
    template: require('./bringoz-select.html').default,
    controller: BringozSelectComponent
  });

